import { STORE_REMOVED_CART_ITEM, DELETE_STORED_CART_ITEM } from '../actionTypes/CartActionTypes';

export default function LastRemovedCartItemReducer(state = {}, action) {
    // NOSONAR
    switch (
        action.type // NOSONAR
    ) {
        case STORE_REMOVED_CART_ITEM: {
            return action.payload;
        }
        case DELETE_STORED_CART_ITEM:
            return {};
        default:
            return state;
    }
}
